
  import React from "react"
  import Component from "/home/lukasz/Projects/Fakturomania/fakturomania-landing-gatsby/src/layouts/index.tsx"
  import data from "/home/lukasz/Projects/Fakturomania/fakturomania-landing-gatsby/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js